const referralApi = REFERRALAPI;
export default class sendEmailApiService {

  sendCode(body) {
    const myHeaders = new Headers();
    myHeaders.append('content-type', 'application/json');
    return fetch(
      `${referralApi}/api/v1/referrals/send_mail`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        headers: myHeaders
      }
    )
      .then(res => res.json());
  }
}
